







import { defineComponent } from '@vue/composition-api';

const CommonValueItem = defineComponent({
  // setup() {},
  props: {
    title: {
      type: String,
    },
    value: {
      type: String,
    },
  },
});

export default CommonValueItem;
